import Page from './components/Page'
import { PRODUCTIVITY_PAGE } from './pages'

export default {
  [PRODUCTIVITY_PAGE]: {
    path: '/reports/inbox/productivity',
    component: Page,
  },
}
